import { Modal } from "react-bootstrap";
import { useRecoilState } from "recoil";
import { selectedAddressTypeState, showChangeBillingAddressModalState } from "atoms";
import { CheckoutFormModel } from "atoms/models";
import ChangeStreetAddress from "./ChangeStreetAddress";
import ChangePOBox from "./ChangePOBox";

const BillingAddressChangeModal: React.FC<{ setCheckoutForm: Function; checkoutForm: CheckoutFormModel; buttonTitle: string }> = ({
  setCheckoutForm,
  checkoutForm,
  buttonTitle,
}) => {
  const [showChangeBillingAddressModal, setShowChangeBillingAddressModal] = useRecoilState(showChangeBillingAddressModalState);
  const [selectedAddressType, setSelectedAddressType] = useRecoilState(selectedAddressTypeState);

  const handleAddressChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedAddressType(event.target.id);
  };

  return (
    <div className="billing-address-change-modal-container">
      <button className="btn btn-secondary change-billing-address-btn ms-0" onClick={() => setShowChangeBillingAddressModal(true)}>
        {buttonTitle}
      </button>
      <Modal show={showChangeBillingAddressModal} onHide={() => setShowChangeBillingAddressModal(false)} size="lg" backdrop="static">
        <Modal.Header closeButton={selectedAddressType === ""}>
          <strong>Change Billing Address</strong>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <h3>Please Select Address Type</h3>
          </div>
          <div className="billing-address-change-modal">
            <div className="form-check">
              <div className="change-address-radio-buttons">
                <input
                  className="form-check-input"
                  type="radio"
                  name="street"
                  id="street"
                  checked={selectedAddressType === "street"}
                  onChange={handleAddressChange}
                />
                <label className="form-check-label" htmlFor="inlineRadio1">
                  Street Address
                </label>
              </div>
              <div>
                <i className="fa-light fa-house" />
              </div>
            </div>
            <div className="form-check">
              <div className="change-address-radio-buttons">
                <input
                  className="form-check-input"
                  type="radio"
                  name="poBox"
                  id="poBox"
                  checked={selectedAddressType === "poBox"}
                  onChange={handleAddressChange}
                />
                <label className="form-check-label" htmlFor="inlineRadio2">
                  PO Box
                </label>
              </div>
              <div>
                <i className="fa-light fa-mailbox" />
              </div>
            </div>
          </div>
          {selectedAddressType === "street" ? <ChangeStreetAddress setCheckoutForm={setCheckoutForm} checkoutForm={checkoutForm} /> : null}
          {selectedAddressType === "poBox" ? <ChangePOBox setCheckoutForm={setCheckoutForm} checkoutForm={checkoutForm} /> : null}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BillingAddressChangeModal;
